// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper__m0aWV","search":"Search_search__2AsUM","icon":"Search_icon__3hW7c"};